<template>
  <div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por Placa, Renavam e CNPJ"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
      
      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>
      
      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>
    
    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>
    
    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label>Contas</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..."/>
        </div>

        <div class="col-md-4">
          <label for="ticket-status">Status</label>
          <Select2 :options="filterStatus" v-model="query.status"/>
        </div>

        <div class="col-md-4">
          <label>Status da análise</label>
          <Select2 :options="filterAnalysisStatus" v-model="query.analysisStatus"/>
        </div>
      </div>
      
      <div class="row mt-4">
        <div class="col-md-6">
          <label for="ticket-day">Data inicial</label>
          <input v-model="query.startDate" type="date" id="ticket-day" class="form-control">
        </div>
        
        <div class="col-md-6">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>
    
    <!-- Table -->
    <div class="row">
      <div class="col-sm-12">
        
        <div class="row mt-4">
          <div class="col-md-12">
            <strong class="mr-3">
              {{infoTotalModels}}
            </strong>
          </div>
        </div>
        
        <Table :ticketHistories="ticketHistories" :linkRequest="true" :linkTicket="true"/>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>
      
      </div>
    </div>
    
  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import ModelMapper from '@/mixins/ModelMapper'
  import handleSearchable from '@/models/handleSearchable'

  import Select2 from '@/components/shares/Select2'
  import Table from './Table'

  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'
  
  export default {
    components: { BadgeFilters, ChevronDownIcon, Pagination, SearchIcon, Select2, Table },
    computed: {
      badgeFilters() {
        return [
          this.filterAccount, this.filterEndDate, this.filterStatus,
          this.filterStartDate, this.filterAnalysisStatus
        ]
      },
      ticketHistories() {
        return this.getModels || []
      },
    },
    created() {
      this.addOrderBy('updatedAt')

      const date = new Date()
      date.setDate(date.getDate())
  
      this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))
      this.$set(this.query, 'running', '')
      
      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })

      this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
    },
    data: () => ({
      accounts: [],
      filterAccount: null,
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      filterStatus: new Filter({
        key: 'status',
        label: 'Status',
        table: [
          ['Todos', ''],
          ['processado', 'processed'],
          ['processando', 'processing'],
          ['aguardando', 'waiting'],
          ['erro', 'error'],
        ]
      }),
      filterAnalysisStatus: new Filter({
        key: 'analysisStatus',
        label: 'Status da análise',
        table: [
          ['Não analisado', 'not_analyzed'],
          ['Em análise', 'analyzing'],
          ['Analisado', 'analyzed'],
        ]
      }),
      nameModel: 'TicketHistory',
      showModal: false,
    }),
    inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
    methods: {
      buildParams(pagination) {
        if (this.query.generic)
          this.query.generic = handleSearchable(this.query.generic)

        return ModelMapper.methods.buildParams.call(this, pagination)
      },
      buildPath() {
        return 'admin/maestro/ticket_histories'
      },
      find() {
        this.asyncTemplateSelect()
      },
    },
    mixins: [ModelMapper],
    name: 'Index',
    watch: {
      allAccounts: {
        deep: true,
        handler(value) {
          this.filterAccount = this.buildFilterAccount(value.data)
        },
      },
      allUsers: {
        deep: true,
        handler(value) {
          this.filterEmail = this.buildFilterEmail(value.data)
        },
      }
    }
  }
</script>

<style scoped>

</style>